import React from 'react';

import { Box } from '@betterment/samba-react';
import Lottie from 'lottie-react';

// eslint-disable-next-line import/extensions
import animationData from './animation-data.json';

const SuccessCheckmark = ({ onAnimationEnd }: { onAnimationEnd?: () => void }) => {
  return (
    <Box css={{ height: '150px', width: '150px', margin: '0 auto' }}>
      <Lottie
        animationData={animationData}
        loop={false}
        onEnterFrame={e => e?.type === 'enterFrame' && e.currentTime >= 15 && onAnimationEnd?.()}
      />
    </Box>
  );
};

export default SuccessCheckmark;
